// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .menu-section[data-v-1d012f14]{cursor:pointer}#app label[data-v-1d012f14]{font-weight:400;line-height:2.2em}#app .clamping-wrapper[data-v-1d012f14]{margin-top:1.5rem}#app .input-group[data-v-1d012f14]{margin-bottom:1rem}#app select[data-v-1d012f14]{width:20rem;height:4rem}", ""]);
// Exports
module.exports = exports;
